import { join, values, map, isPresent, fill, includes } from 'lodash'
const ASSET_NAME_SEGMENTS = {
  'site': '[Site]',
  'clientCode': '[Client Code]',
  'separator1': '-',
  'assetType': '[Asset Type]',
  'separator2': '-',
  'uid': 'UID',
}

const DEFAULT_ASSET_NAME_TEMPLATE = join(values(ASSET_NAME_SEGMENTS), '')

const assetNameWorkflow = (fieldName, newValueToReplace, prevFormState) => (
  new Promise((resolve, reject) => {
    const assetNameTemplate = generateAssetName(fieldName, newValueToReplace, prevFormState)

    resolve({ assetNameTemplate, formState: prevFormState })
  }).then(({ assetNameTemplate, formState }) => {
    const assetNames = iterateAssetNames(assetNameTemplate, formState.amountReserving)

    return Promise.resolve({ assetNameTemplate, formState, assetNames })
  }).catch((e) => {
    console.log(e)
  })
)

const generateAssetName = (fieldName, newValueToReplace, formState) => {
  const newAssetName = map(ASSET_NAME_SEGMENTS, (value, key) => {
    // Wipe uid on other field change. We need the user to check the availability again.
    if (key === 'uid' && includes(['location', 'clientCode', 'assetType'], fieldName)) {
      return value
    }

    if (key === fieldName) { return newValueToReplace }
    else if (isPresent(formState[key])) { return formState[key] }

    return value
  })

  return join(newAssetName, '')
}

const iterateAssetNames = (assetNameTemplate, amountReserving) => (
  map(fill(Array(amountReserving), assetNameTemplate), (name, index) => {
    if (name.slice(-3) != 'UID') {
      const allButLastThreeDigitsInTemplate = name.slice(0, -3)
      const uidNumber = String(parseInt(name.slice(-3)) + index).padStart(3, '0')

      return allButLastThreeDigitsInTemplate + uidNumber
    }

    return assetNameTemplate
  })
)

export { assetNameWorkflow, DEFAULT_ASSET_NAME_TEMPLATE }
